import React, { useState, useContext } from "react";
import { FirebaseContext } from "../../../FirebaseContext";
import { SelectionButton } from "../SelectionButton/";
import './SelectAbility.css';
import './DiceRoller.css';
import arrayIcon from '../../../Images/ability/array.webp';
import diceIcon from '../../../Images/ability/dice.webp';
import pointBuyIcon from '../../../Images/ability/point_buy.webp';

const DiceRoller = () => {
    const [diceValues, setDiceValues] = useState([null, null, null, null]); // No values initially
    const [rolling, setRolling] = useState(false);
    const [rolled, setRolled] = useState(false); // Track if the dice have been rolled
    const [lowestIndex, setLowestIndex] = useState(null); // Track the index of the lowest dice
    const [isFinal, setIsFinal] = useState(false); // Flag to track if the roll is final

    // Function to roll the dice and set random values between 1 and 6
    const rollDice = () => {
        // Prevent further rolls if the roll is final
        if (isFinal) return;

        setRolling(true);
        setTimeout(() => {
            const newDiceValues = Array(4).fill(null).map(() => Math.floor(Math.random() * 6) + 1);
            
            // Find the index of the lowest dice value
            const minValue = Math.min(...newDiceValues);
            const minIndex = newDiceValues.indexOf(minValue);
            
            setDiceValues(newDiceValues);
            setLowestIndex(minIndex); // Store the index of the lowest value dice
            setRolled(true); // Set rolled to true after first roll
            setRolling(false);
            setIsFinal(true); // Set the roll as final after the first roll
        }, 1000); // Set delay for dice rolling animation
    };

    // Sum of the dice values excluding the lowest value (only calculated when the dice have been rolled)
    const sum = rolled 
        ? diceValues.reduce((acc, val, index) => (index === lowestIndex ? acc : acc + val), 0)
        : null;

    return (
        <div
            className={`dice-roller ${rolling ? 'rolling' : ''} ${isFinal ? 'final' : 'glowing'}`}
            onClick={rollDice}
        >
            {/* Dice with conditional rendering, showing numbers only after the first roll */}
            <div className={`dice top-left ${lowestIndex === 0 ? 'crossed-out' : ''}`}>
                {diceValues[0] !== null ? diceValues[0] : ''}
            </div>
            <div className={`dice top-right ${lowestIndex === 1 ? 'crossed-out' : ''}`}>
                {diceValues[1] !== null ? diceValues[1] : ''}
            </div>
            <div className={`dice bottom-left ${lowestIndex === 2 ? 'crossed-out' : ''}`}>
                {diceValues[2] !== null ? diceValues[2] : ''}
            </div>
            <div className={`dice bottom-right ${lowestIndex === 3 ? 'crossed-out' : ''}`}>
                {diceValues[3] !== null ? diceValues[3] : ''}
            </div>
            
            {/* Show "Roll Me" before the first roll, otherwise show the sum */}
            {!rolling && (
                <div className="sum">
                    {rolled ? sum : 'Roll Me'}
                </div>
            )}
        </div>
    );
};

export const SelectAbility = () => {
    const { characterJSON, setCharacterJSON } = useContext(FirebaseContext);
    const [selectedMethod, setSelectedMethod] = useState(null); // State for tracking the selected method

    const selectingMethod = (method) => {
        // Toggle selection: if the same method is clicked, deselect by setting it to null
        setSelectedMethod(prevMethod => prevMethod === method ? null : method);
    };

    return (
        <div className="content-wrapper">
            <h2 className="character-heading">
                Choose a method:
            </h2>             
            <div className="character-grid">
                <SelectionButton
                    key={"Standard Array"}
                    name={"Standard Array"}
                    icon={arrayIcon}
                    onClick={() => selectingMethod("Array")}
                    disabled={true}
                />
                <SelectionButton
                    key={"Random Generation"}
                    name={"Random Generation"}
                    icon={diceIcon}
                    isSelected={selectedMethod === "Random"}
                    onClick={() => selectingMethod("Random")}
                />
                <SelectionButton
                    key={"Point Cost"}
                    name={"Point Cost"}
                    icon={pointBuyIcon}
                    onClick={() => selectingMethod("Cost")}
                    disabled={true}
                />
            </div>

            {selectedMethod === "Random" && (
                <>
                    <h2 className="character-heading">
                        Randomly generate stats:
                    </h2>
                    <div className="character-grid">
                        <DiceRoller />
                        <DiceRoller />
                        <DiceRoller />
                        <DiceRoller />
                        <DiceRoller />
                        <DiceRoller />
                    </div>
                </>
            )}
        </div>
    );
};
